import { __zcFin, __zcIT, __zcITc, __zcMkv, __zcRd, __zcRf } from "__zod-compiler-runtime__";
import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {FormFieldTextInputSchema} from './formFieldTextInput'
import {FormFieldTextAreaSchema} from './formFieldTextArea'
import {FormFieldSelectSchema} from './formFieldSelect'
import {FormFieldCheckboxGroupSchema} from './formFieldCheckboxGroup'

export const TwoColumnFormLayoutSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('twoColumnFormLayout', {
  fields: z.lazy(() =>
    z.object({
      rows: z
        .array(
          buildEntrySchemaFor('row', {
            fields: z.lazy(() =>
              z.object({
                fields: z
                  .array(
                    z
                      .union([
                        FormFieldTextInputSchema,
                        FormFieldTextAreaSchema,
                        FormFieldCheckboxGroupSchema,
                        FormFieldSelectSchema,
                      ])
                      .readonly(),
                  )
                  .readonly(),
              }),
            ),
          }),
        )
        .readonly(),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType];
var __rfz_0=__rf[0]._zod;
var __rfz_1=__rf[1]._zod;
function safeParse_TwoColumnFormLayoutSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_1=_d["sys"];if(typeof __sv_1!=="object"||__sv_1===null||Array.isArray(__sv_1)){_e.push(__zcIT("object",__sv_1,["sys"]));}else{var __sv_3=__sv_1["id"];if(typeof __sv_3!=="string"){_e.push(__zcIT("string",__sv_3,["sys","id"]));}
var __sv_4=__sv_1["updatedAt"];if(__sv_4!==undefined){if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","updatedAt"]));}
}
var __sv_5=__sv_1["createdAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","createdAt"]));}
}
var __sv_6=__sv_1["contentType"];var __op_8="contentType" in __sv_1;var __ob_7=_e.length;var __rf_c0={async:false};var __rf_r0=__zcRd(__rfz_0,__sv_6,__rf_c0);if(__rf_r0.issues.length){__zcRf(__rf_r0.issues,__rf_c0,_e,["sys","contentType"]);}else{__sv_6=__rf_r0.value;}
if(!__op_8){__sv_6=undefined;if(_e.length===__ob_7){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_2={"id":__sv_3};if(__sv_4!==undefined||("updatedAt" in __sv_1)){__o_2["updatedAt"]=__sv_4;}if(__sv_5!==undefined||("createdAt" in __sv_1)){__o_2["createdAt"]=__sv_5;}if(__sv_6!==undefined||("contentType" in __sv_1)){__o_2["contentType"]=__sv_6;}__sv_1=__o_2;}
var __sv_9=_d["fields"];var __op_11="fields" in _d;var __ob_10=_e.length;var __rf_c1={async:false};var __rf_r1=__zcRd(__rfz_1,__sv_9,__rf_c1);if(__rf_r1.issues.length){__zcRf(__rf_r1.issues,__rf_c1,_e,["fields"]);}else{__sv_9=__rf_r1.value;}
if(!__op_11){__sv_9=undefined;if(_e.length===__ob_10){_e.push(__zcITc("nonoptional",undefined,["fields"]));}}var __o_0={"sys":__sv_1};if(__sv_9!==undefined||("fields" in _d)){__o_0["fields"]=__sv_9;}_d=__o_0;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_TwoColumnFormLayoutSchema,__zs,null,null);
})()

export type TwoColumnFormLayout = z.infer<typeof TwoColumnFormLayoutSchema>
